import React from 'react';
import { ethers } from 'ethers';

const IncomeOverview = ({ userInfo }) => {
  // Calculate values from userInfo or use defaults
  const referralIncome = userInfo ? parseFloat(userInfo.refIncomeUSDT).toFixed(2) : '0';
  const royaltyIncome = userInfo ? parseFloat(userInfo.royaltyIncomeUSDT).toFixed(2) : '0';
  
  // Calculate total income
  const totalIncome = userInfo 
    ? (parseFloat(userInfo.refIncomeUSDT) + parseFloat(userInfo.royaltyIncomeUSDT)).toFixed(2)
    : '0';

  return (
    <div className="income-overview">
      <h2>Income Overview</h2>
      <div className="income-cards">
        <div className="income-card">
          <div className="income-type">Referral Income</div>
          <div className="income-value">{referralIncome} USDT</div>
        </div>
        <div className="income-card">
          <div className="income-type">Royalty Income</div>
          <div className="income-value">{royaltyIncome} USDT</div>
        </div>
        <div className="income-card">
          <div className="income-type">Total Income</div>
          <div className="income-value">{totalIncome} USDT</div>
        </div>
      </div>
    </div>
  );
};

export default IncomeOverview;
